import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { Modal, MessageBoxFunctionalLayout, Text } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { NavigationContext } from '@src/context/navigation-store/navigation-store';
import { isWaitingForRouteApproval } from '@src/context/navigation-store/selectors';
import { withBIModalEvents, ModalProps } from '../with-bi-modal-events/with-bi-modal-events';
import { PopupType } from '@src/context/actions/bi';

type Props = ModalProps & InjectedTranslateProps & { isOpen: boolean };
const NavigationPromptComponent = translate()(({ t, isOpen, onOk, onClose, onCancel }: Props) => (
  <Modal dataHook={DataHooks.StopNavigationModal} isOpen={isOpen} onRequestClose={onClose} shouldCloseOnOverlayClick>
    <MessageBoxFunctionalLayout
      dataHook={DataHooks.StopNavigationPrompt}
      confirmText={t('stop.navigation.prompt.stay')}
      onOk={onCancel}
      cancelText={t('stop.navigation.prompt.leave')}
      onCancel={onOk}
      onClose={onClose}
      title={t('stop.navigation.prompt.title')}
      width="600px"
    >
      <Text>{t('stop.navigation.prompt.message')}</Text>
    </MessageBoxFunctionalLayout>
  </Modal>
));

const NavigationPromptWithBI = withBIModalEvents(PopupType.SureYouWantToLeave)(NavigationPromptComponent);

export const NavigationPrompt = () => {
  const store = React.useContext(NavigationContext);
  const waitingForRouteApproval = isWaitingForRouteApproval(store);
  const closeModal = store.cancelNavigation;
  const approveNavigation = store.resumeNavigation;

  return <NavigationPromptWithBI isOpen={waitingForRouteApproval} onOk={approveNavigation} onCancel={closeModal} />;
};
